import React, {Component} from 'react';
import './styles.scss';
import Asset from 'src/requests/apa/Asset';
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardVoid extends Component {
  constructor(props) {
    super(props);
    this.placeholder = Asset.get('ribbons_placeholder_' + props.placeholder + '_background', '') || Asset.get('ribbons_placeholder_generic_background', '');
    this.state = { imageReady: !_isPS4 };
    this._coverRef = null;
    this._loadTimer = null;

    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache
    this._cachedCoverStyle = null;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.imageReady !== nextState.imageReady;
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  render() {
    const imageReady = this.state.imageReady;
    if (!this._cachedCoverStyle || this._prevImageReady !== imageReady) {
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(this.placeholder, imageReady);
    }

    return (
      <div className={'card card-void'}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            <div
              ref={this._setCoverRef}
              className="card-placeholder"
              style={this._cachedCoverStyle}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CardVoid;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardVoid/index.js